import { createVNode as _createVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-abe834dc")

_pushScopeId("data-v-abe834dc")
const _hoisted_1 = { class: "select-size" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", null, "Step1：1コマのサイズ指定", -1)
const _hoisted_4 = { class: "sizes" }
const _hoisted_5 = { class: "select" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", { for: "size_fb" }, "Facebook一般向け：", -1)
const _hoisted_7 = { class: "option superduper-indent" }
const _hoisted_8 = { class: "select" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", { for: "size_fb_ad" }, [
  /*#__PURE__*/_createVNode("span", null, "Facebook"),
  /*#__PURE__*/_createVNode("span", { class: "block" }, "カルーセル広告向け：")
], -1)
const _hoisted_10 = { class: "option superduper-indent" }
const _hoisted_11 = { class: "select" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", { for: "size_twitter" }, "Twitter向け：", -1)
const _hoisted_13 = { class: "option superduper-indent" }
const _hoisted_14 = { class: "select" }
const _hoisted_15 = /*#__PURE__*/_createVNode("label", { for: "size_instagram" }, "Instagram向け：", -1)
const _hoisted_16 = { class: "option superduper-indent" }
const _hoisted_17 = { class: "select" }
const _hoisted_18 = /*#__PURE__*/_createVNode("label", { for: "size_other_p" }, "その他(%指定)：", -1)
const _hoisted_19 = { class: "option" }
const _hoisted_20 = { class: "select" }
const _hoisted_21 = /*#__PURE__*/_createVNode("label", { for: "size_other_px" }, "その他(px指定)：", -1)
const _hoisted_22 = { class: "option" }
const _hoisted_23 = /*#__PURE__*/_createVNode("label", null, "横：", -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("label", null, "px × 縦：", -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("label", null, "px", -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("p", { class: "annotation" }, "※ 画像のアスペクト比（縦横比）は維持されます", -1)
const _hoisted_27 = { class: "commands" }
const _hoisted_28 = /*#__PURE__*/_createVNode("span", null, "次へ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InputNumber = _resolveComponent("InputNumber")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _withDirectives(_createVNode("input", {
            id: "size_fb",
            name: "size",
            type: "radio",
            value: _ctx.mode.fb,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.sizeMode = $event))
          }, null, 8, ["value"]), [
            [_vModelRadio, _ctx.state.sizeMode]
          ]),
          _hoisted_6
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("label", null, "横：" + _toDisplayString(_ctx.consts.fbSize.width) + "px × 縦：" + _toDisplayString(_ctx.consts.fbSize.height) + "px", 1)
        ]),
        _createVNode("div", _hoisted_8, [
          _withDirectives(_createVNode("input", {
            id: "size_fb_ad",
            name: "size",
            type: "radio",
            value: _ctx.mode.fbad,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.sizeMode = $event))
          }, null, 8, ["value"]), [
            [_vModelRadio, _ctx.state.sizeMode]
          ]),
          _hoisted_9
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("label", null, "横：" + _toDisplayString(_ctx.consts.fbadSize.width) + "px × 縦：" + _toDisplayString(_ctx.consts.fbadSize.height) + "px", 1)
        ]),
        _createVNode("div", _hoisted_11, [
          _withDirectives(_createVNode("input", {
            id: "size_twitter",
            name: "size",
            type: "radio",
            value: _ctx.mode.tw,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.sizeMode = $event))
          }, null, 8, ["value"]), [
            [_vModelRadio, _ctx.state.sizeMode]
          ]),
          _hoisted_12
        ]),
        _createVNode("div", _hoisted_13, [
          _createVNode("label", null, "横：" + _toDisplayString(_ctx.consts.twSize.width) + "px × 縦：" + _toDisplayString(_ctx.consts.twSize.height) + "px", 1)
        ]),
        _createVNode("div", _hoisted_14, [
          _withDirectives(_createVNode("input", {
            id: "size_instagram",
            name: "size",
            type: "radio",
            value: _ctx.mode.inst,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.sizeMode = $event))
          }, null, 8, ["value"]), [
            [_vModelRadio, _ctx.state.sizeMode]
          ]),
          _hoisted_15
        ]),
        _createVNode("div", _hoisted_16, [
          _createVNode("label", null, "横：" + _toDisplayString(_ctx.consts.instSize.width) + "px × 縦：" + _toDisplayString(_ctx.consts.instSize.height) + "px", 1)
        ]),
        _createVNode("div", _hoisted_17, [
          _withDirectives(_createVNode("input", {
            id: "size_other_p",
            name: "size",
            type: "radio",
            value: _ctx.mode.per,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.sizeMode = $event))
          }, null, 8, ["value"]), [
            [_vModelRadio, _ctx.state.sizeMode]
          ]),
          _hoisted_18
        ]),
        _createVNode("div", _hoisted_19, [
          _createVNode(_component_InputNumber, {
            class: "per-input",
            value: _ctx.roundedPercent,
            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateByPercent($event / 100.0))),
            minValue: _ctx.round(_ctx.consts.downloadSizeMinScale * 100),
            maxValue: _ctx.round(_ctx.consts.downloadSizeMaxScale * 100),
            defValue: 90
          }, null, 8, ["value", "minValue", "maxValue"]),
          _createTextVNode(" % (" + _toDisplayString(_ctx.round(_ctx.consts.downloadSizeMinScale * 100)) + "% 〜 " + _toDisplayString(_ctx.round(_ctx.consts.downloadSizeMaxScale * 100)) + "%) ", 1)
        ]),
        _createVNode("div", _hoisted_20, [
          _withDirectives(_createVNode("input", {
            id: "size_other_px",
            name: "size",
            type: "radio",
            value: _ctx.mode.px,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.sizeMode = $event))
          }, null, 8, ["value"]), [
            [_vModelRadio, _ctx.state.sizeMode]
          ]),
          _hoisted_21
        ]),
        _createVNode("div", _hoisted_22, [
          _hoisted_23,
          _createVNode(_component_InputNumber, {
            class: "num-input",
            value: _ctx.roundedWidth,
            "onUpdate:value": _ctx.updateByWidth,
            minValue: _ctx.round(_ctx.originalSize.width * _ctx.consts.downloadSizeMinScale),
            maxValue: _ctx.round(_ctx.originalSize.width * _ctx.consts.downloadSizeMaxScale),
            defValue: _ctx.consts.fbSize.width
          }, null, 8, ["value", "onUpdate:value", "minValue", "maxValue", "defValue"]),
          _hoisted_24,
          _createVNode(_component_InputNumber, {
            class: "num-input",
            value: _ctx.roundedHeight,
            "onUpdate:value": _ctx.updateByHeight,
            minValue: _ctx.round(_ctx.originalSize.height * _ctx.consts.downloadSizeMinScale),
            maxValue: _ctx.round(_ctx.originalSize.height * _ctx.consts.downloadSizeMaxScale),
            defValue: _ctx.consts.fbSize.height
          }, null, 8, ["value", "onUpdate:value", "minValue", "maxValue", "defValue"]),
          _hoisted_25
        ])
      ]),
      _hoisted_26
    ]),
    _createVNode("div", _hoisted_27, [
      _createVNode("button", {
        class: "primary-button",
        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
      }, [
        _hoisted_28
      ])
    ])
  ]))
})